import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Upload } from 'lucide-react';
import { Button } from '../ui/button';

// Sticky Mobile CTA removed - no longer needed
export default function StickyMobileCTA() {
  return null;
}
